module.exports = __webpack_public_path__ + "img/logoyruy.dea0f23d.png";